export default __webpack_public_path__ + "static/media/1797.9d4fe187.png";